export default {
    isAuthenticated: state => !!state.access_tokenn,
    isMember: state => state.dados,
    authStatus: state => state.status,
    authErrors: state => state.errors,
}
